import React from 'react';
import { Helmet } from 'react-helmet';

const Meta = ({ title, description }) => { 
  const theme = getComputedStyle(document.body).getPropertyValue('--body-background-color');

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <meta id="theme_color" name="theme-color" content={theme.trim()} />
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
};

export default Meta;
